// @mui
import { styled, alpha } from "@mui/material/styles";
import { Box, Button, IconButton, Stack, Typography } from "@mui/material";
// auth
import { useAuthContext } from "../../../auth/useAuthContext";
// components
import { CustomAvatar } from "../../../components/custom-avatar";
import { sentenceCase } from "change-case";
import fetcher from "src/api/fetcher";
import { END_POINTS } from "src/api/EndPoints";
import { useEffect, useState } from "react";
import useCopyToClipboard from "src/hooks/useCopyToClipboard";
import { useSnackbar } from "notistack";
import Iconify from "src/components/iconify";

// ----------------------------------------------------------------------

const StyledRoot = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(1, 2),
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
  backgroundColor: alpha(theme.palette.grey[500], 0.12),
}));

// ----------------------------------------------------------------------

export default function NavAccount() {
  const { copy } = useCopyToClipboard();
  const { enqueueSnackbar } = useSnackbar();
  const { user } = useAuthContext();

  const handleCopy = (val: string | undefined) => {
    enqueueSnackbar("Copied!");
    val && copy(val);
  };

  return (
    <StyledRoot>
      <CustomAvatar src={""} alt={""} name={user?.firstName} />

      <Box sx={{ ml: 2, minWidth: 0 }}>
        <Typography variant="subtitle2" noWrap>
          {sentenceCase(`${user?.firstName} ${user?.lastName}` || "")}
        </Typography>
        <Stack flexDirection="row" gap={1} alignItems={"center"}>
          <Typography variant="body2" noWrap sx={{ color: "text.secondary" }}>
            {user?.referral?.code}
          </Typography>
          <Iconify
            icon={"iconamoon:copy"}
            color={"primary.main"}
            sx={{ cursor: "pointer" }}
            onClick={() => handleCopy(user?.referral?.code)}
          />
        </Stack>
        {/* <Typography variant="body2" color={"text.secondary"} noWrap>
          {user?.referral}{" "}
          <IconButton onClick={() => handleCopy(user?.referral)}>
            <Iconify icon="eva:copy-fill" width={20} />
          </IconButton>
        </Typography> */}
      </Box>
    </StyledRoot>
  );
}
